import ResizedImage from 'shared/components/resized-image/resized-image';
import ThumbnailOverlayCompact from './thumbnail-overlay/thumbnail-overlay';
import { getVideoCoverUrl } from 'shared/ui-selectors/video/cover';

export default class VideoListItem extends React.Component {
  static propTypes = {
    className: React.PropTypes.string,
    channelData: React.PropTypes.object,
    appSettings: React.PropTypes.object,
    videoItem: React.PropTypes.object,
    thumbnailSize: React.PropTypes.shape({
      width: React.PropTypes.number,
      height: React.PropTypes.number,
    }),

    onClick: React.PropTypes.func,
    onPlayClicked: React.PropTypes.func,
  };

  render() {
    const {
      className,
      channelData,
      appSettings,
      thumbnailSize,
      videoItem,
      onClick,
    } = this.props;

    const { height, width } = thumbnailSize;

    return (
      <div className={className}
           style={{ height }}
           onClick={onClick}>
        <ResizedImage src={getVideoCoverUrl(videoItem)}
                      {...thumbnailSize} />
        <ThumbnailOverlayCompact channelData={channelData}
                                 videoItem={videoItem}
                                 width={width}
                                 appSettings={appSettings}
                                 playSelectedVideo={this.onPlayClicked} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/video-list-item/video-list-item.js